import { EventsEndpoints } from "@/graph/event/endpoints"
import { SelectOption } from "@apg.gg/core/lib/Select"
import { UseQueryResult, useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

export const useEventTypes = (): UseQueryResult<SelectOption[]> => {
  const eventTypes = useQuery({
    queryKey: ['apg-event-types'],
    queryFn: () => EventsEndpoints.getEventTypes(),
    staleTime: 1000 * 60 * 10
  })

  return eventTypes
}

export const useEventTags = (): UseQueryResult<SelectOption[]> => {
  const eventTags = useQuery({
    queryKey: ['apg-event-tags'],
    queryFn: () => EventsEndpoints.getEventTags(),
    staleTime: 1000 * 60 * 10
  })

  return eventTags
}

export const useEventCategories = (): UseQueryResult<SelectOption[]> => {
  const eventCategories = useQuery({
    queryKey: ['apg-event-categories'],
    queryFn: () => EventsEndpoints.getEventCategories(),
    staleTime: 1000 * 60 * 10
  })

  return eventCategories
}

type JoinEventParams = {
  eventSlug: string;
  token: string;
}

export const useJoinEvent = ({
  eventSlug,
  token
}: JoinEventParams) => {
  const queryClient = useQueryClient()
  
  return useMutation(
    {
      mutationFn: (eventId: number) => EventsEndpoints.joinEvent({ eventId, token }),
      onSuccess: (data) => {
        queryClient.refetchQueries({ queryKey: ['apg-event-detail', eventSlug]});
        queryClient.refetchQueries({ queryKey: ['apg-event-participants', eventSlug]});
      },
    }
  );
}